import {
  createAppI18n,
  defaultLang,
  loadLocalTranslations,
  registerI18nInstance
} from '@shared/locales'

export const cmsI18n = createAppI18n()

const initializeCmsI18n = async (lang: string) => {
  await loadLocalTranslations(cmsI18n, 'cms', lang)
}

registerI18nInstance(cmsI18n)

let lastLoadedLang: string | null = null

cmsI18n.on('languageChanged', async (newLang) => {
  if (newLang !== lastLoadedLang) {
    await initializeCmsI18n(newLang)
    lastLoadedLang = newLang
  }
})

const initializeDefaultLanguage = async () => {
  const lang = cmsI18n.language || defaultLang.value

  await initializeCmsI18n(lang)
}

initializeDefaultLanguage()
